import { useContextSelector as useCS } from 'use-context-selector';
import { useRequest } from 'domain/core/hooks/useRequest';
import { TUpdate } from 'domain/types';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import {
  NotificationSettings,
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import { useEffect } from 'react';
import { showSystemToast } from 'view/components/SystemToast';

export const useUpdateNotificationsSettings = (): any => {
  const notificationSettings: NotificationSettings = useCS(
    ProfileConfigContext,
    profileConfigSelectors.notificationSettings
  );
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );

  const { isLoading, data, error, send } = useRequest({
    url: 'api/v1/notifications/settings',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
    body: {},
  });

  const updateNotificationSetting = (body: Record<string, boolean>) => {
    send({ ...body }).then();
  };

  useEffect(() => {
    if (!isLoading && !error && data) {
      if (update) update({ notificationSettings: { ...notificationSettings, ...data } });
      showSystemToast(
        'success', // или 'info', в зависимости от дизайна
        'Notifications Settings Updated',
        'Your changes have been saved successfully.'
      );
    }
  }, [isLoading, error, data, update]);

  return {
    isLoading,
    error: error || null,
    updateNotificationSetting,
  };
};
